const PartnerTypeEnum = {
  Customer: 1,
  Store: 2,
};
export default PartnerTypeEnum;
